import { createContext, ReactNode, useContext } from 'react';
import { useDepartmentScope } from '@/modules/shared/hr-lookups';

/**
 * Which departments a reviewer's request list covers: `team` (Team Requests) only the departments
 * they head plus their own; `all` (All Requests) every department their permissions allow.
 */
export type RequestScope = 'team' | 'all';

const RequestScopeContext = createContext<RequestScope>('all');

export const RequestScopeProvider = ({
  scope,
  children,
}: {
  scope: RequestScope;
  children: ReactNode;
}) => <RequestScopeContext.Provider value={scope}>{children}</RequestScopeContext.Provider>;

/** `useDepartmentScope` for the request list's tab, so the five type lists need no scope prop. */
export const useRequestScope = () =>
  useDepartmentScope({ teamOnly: useContext(RequestScopeContext) === 'team' });
